var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M30.7,198.4c-25.1,139.2,142.7,50.3,196.8,61.3c38.8,7.9,77.7,80.9,130.5,82.9 c55.5,2.1,97.8-51.4,104.6-99.6C472.7,170.2,371,25.6,281.7,39.6C214,50.3,224.3,146.2,161,166.2 C121.2,178.7,44.3,122.5,30.7,198.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M30.7,198.4c-25.1,139.2,142.7,50.3,196.8,61.3 c38.8,7.9,77.7,80.9,130.5,82.9c55.5,2.1,97.8-51.4,104.6-99.6C472.7,170.2,371,25.6,281.7,39.6C214,50.3,224.3,146.2,161,166.2 C121.2,178.7,44.3,122.5,30.7,198.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-48"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-48",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 451.9,
    rx: 236,
    ry: 13.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-48"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 276.4,
    transform: "matrix(0.9932 -0.1162 0.1162 0.9932 -33.0453 4.8547)",
    style: {
      fill: "#35A464"
    },
    width: 1.2,
    height: 18.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 302.2,
    transform: "matrix(0.9932 -0.1162 0.1162 0.9932 -35.4817 5.2772)",
    style: {
      fill: "#35A464"
    },
    width: 1.2,
    height: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M109.5,238.2l-1.5-4.1c-2.1-5.8-7.9-9.4-14-8.7l-58.2,6.8c-7.3,0.9-12.4,7.4-11.6,14.7l16.6,141.6 c0.6,5,5.1,8.5,10.1,8l0,0L259,372.2c5-0.6,8.6-5.1,8-10l0,0l-14.4-122.4c-0.6-5-5.1-8.5-10.1-8l-120.9,14.1 C116.4,246.4,111.3,243.3,109.5,238.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 182.3,
    transform: "matrix(0.9807 -0.1954 0.1954 0.9807 -42.8824 22.2922)",
    style: {
      fill: "#35A464"
    },
    width: 67.1,
    height: 92.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 182.3,
    transform: "matrix(0.9807 -0.1954 0.1954 0.9807 -42.8824 22.2922)",
    style: {
      opacity: 0.7,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 67.1,
    height: 92.4
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M106.6,198.4L66,206.5c-2,0.4-3.9-0.9-4.3-2.8l0,0c-0.4-2,0.9-3.9,2.8-4.3l40.5-8 c2-0.4,3.9,0.9,4.3,2.8l0,0C109.8,196.1,108.5,198,106.6,198.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M109.5,213.4L69,221.5c-2,0.4-3.9-0.9-4.3-2.8l0,0c-0.4-2,0.9-3.9,2.8-4.3l40.5-8.1 c2-0.4,3.9,0.9,4.3,2.8l0,0C112.7,211.1,111.5,213,109.5,213.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M112.5,228.4L72,236.5c-2,0.4-3.9-0.9-4.3-2.8l0,0c-0.4-2,0.9-3.9,2.8-4.3l40.5-8.1 c2-0.4,3.9,0.9,4.3,2.8l0,0C115.7,226.1,114.5,228,112.5,228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M115.5,243.4L75,251.5c-2,0.4-3.9-0.9-4.3-2.8l0,0c-0.4-2,0.9-3.9,2.8-4.3l40.5-8.1 c2-0.4,3.9,0.9,4.3,2.8l0,0C118.7,241.1,117.5,243,115.5,243.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M107.4,260.6L78,266.4c-2,0.4-3.9-0.9-4.3-2.8l0,0c-0.4-2,0.9-3.9,2.8-4.3l29.4-5.9 c2-0.4,3.9,0.9,4.3,2.8l0,0C110.6,258.3,109.4,260.2,107.4,260.6z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 148.6,
    y: 163.3,
    transform: "matrix(0.9908 -0.1355 0.1355 0.9908 -26.7073 26.6125)",
    style: {
      fill: "#35A464"
    },
    width: 67.1,
    height: 92.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.6,
    y: 163.3,
    transform: "matrix(0.9908 -0.1355 0.1355 0.9908 -26.7073 26.6125)",
    style: {
      opacity: 0.7,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 67.1,
    height: 92.4
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M199,180.4l-41,5.6c-2,0.3-3.8-1.1-4.1-3.1l0,0c-0.3-2,1.1-3.8,3.1-4.1l40.9-5.6 c2-0.3,3.8,1.1,4.1,3.1l0,0C202.3,178.3,200.9,180.1,199,180.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M201,195.5l-40.9,5.6c-2,0.3-3.8-1.1-4.1-3.1l0,0c-0.3-2,1.1-3.8,3.1-4.1l40.9-5.6 c2-0.3,3.8,1.1,4.1,3.1l0,0C204.4,193.4,203,195.2,201,195.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M173.4,214.7l-11.3,1.5c-2,0.3-3.8-1.1-4.1-3.1l0,0c-0.3-2,1.1-3.8,3.1-4.1l11.3-1.5 c2-0.3,3.8,1.1,4.1,3.1l0,0C176.8,212.6,175.4,214.4,173.4,214.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M195.3,211.7l-11.3,1.5c-2,0.3-3.8-1.1-4.1-3.1l0,0c-0.3-2,1.1-3.8,3.1-4.1l11.3-1.5 c2-0.3,3.8,1.1,4.1,3.1l0,0C198.7,209.6,197.3,211.4,195.3,211.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M205.2,225.8l-40.9,5.6c-2,0.3-3.8-1.1-4.1-3.1l0,0c-0.3-2,1.1-3.8,3.1-4.1l40.9-5.6 c2-0.3,3.8,1.1,4.1,3.1l0,0C208.5,223.7,207.1,225.5,205.2,225.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M196.1,242.5l-29.7,4.1c-2,0.3-3.8-1.1-4.1-3.1l0,0c-0.3-2,1.1-3.8,3.1-4.1l29.7-4.1 c2-0.3,3.8,1.1,4.1,3.1l0,0C199.4,240.3,198,242.2,196.1,242.5z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 175.3,
    transform: "matrix(0.9962 -8.681017e-02 8.681017e-02 0.9962 -18.7865 10.9887)",
    style: {
      fill: "#35A464"
    },
    width: 67.1,
    height: 92.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 175.3,
    transform: "matrix(0.9962 -8.681017e-02 8.681017e-02 0.9962 -18.7865 10.9887)",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 67.1,
    height: 92.4
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M135.2,193.2L94,196.8c-2,0.2-3.7-1.3-3.9-3.3l0,0c-0.2-2,1.3-3.7,3.3-3.9l41.2-3.7 c2-0.2,3.7,1.3,3.9,3.3l0,0C138.7,191.3,137.3,193,135.2,193.2L135.2,193.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M136.6,208.5l-41.2,3.7c-2,0.2-3.7-1.3-3.9-3.3l0,0c-0.2-2,1.3-3.7,3.3-3.9l41.2-3.7 c2-0.2,3.7,1.3,3.9,3.3l0,0C140,206.5,138.5,208.3,136.6,208.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M137.9,223.7l-41.2,3.7c-2,0.2-3.7-1.3-3.9-3.3l0,0c-0.2-2,1.3-3.7,3.3-3.9l41.2-3.7 c2-0.2,3.7,1.3,3.9,3.3l0,0C141.3,221.7,139.9,223.5,137.9,223.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M139.2,238.9L98,242.6c-2,0.2-3.7-1.3-3.9-3.3l0,0c-0.2-2,1.3-3.7,3.3-3.9l41.2-3.6 c2-0.2,3.7,1.3,3.9,3.3l0,0C142.7,237,141.2,238.7,139.2,238.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M129.3,255.1l-29.9,2.6c-2,0.2-3.8-1.3-4-3.3l0,0c-0.2-2,1.3-3.7,3.3-3.9l29.9-2.6 c2-0.2,3.7,1.3,3.9,3.3l0,0C132.7,253.1,131.3,254.9,129.3,255.1z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 169.6,
    transform: "matrix(0.9988 -4.815439e-02 4.815439e-02 0.9988 -10.1631 9.7147)",
    style: {
      fill: "#35A464"
    },
    width: 67.1,
    height: 92.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 169.6,
    transform: "matrix(0.9988 -4.815439e-02 4.815439e-02 0.9988 -10.1631 9.7147)",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 67.1,
    height: 92.4
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M215.8,188.3l-41.3,2c-2,0.1-3.7-1.5-3.8-3.4l0,0c-0.1-2,1.5-3.7,3.4-3.8l41.3-2 c2-0.1,3.7,1.5,3.8,3.4l0,0C219.4,186.5,217.8,188.2,215.8,188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M216.6,203.6l-41.3,2c-2,0.1-3.7-1.5-3.8-3.4l0,0c-0.1-2,1.5-3.7,3.5-3.8l41.3-2 c2-0.1,3.7,1.5,3.8,3.5l0,0C220.1,201.8,218.6,203.5,216.6,203.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M187.4,220.3l-11.4,0.5c-2,0.1-3.7-1.5-3.8-3.4l0,0c-0.1-2,1.5-3.7,3.4-3.8L187,213 c2-0.1,3.7,1.5,3.8,3.5l0,0C191,218.5,189.4,220.2,187.4,220.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M209.5,219.2l-11.4,0.5c-2,0.1-3.7-1.5-3.8-3.4l0,0c-0.1-2,1.5-3.7,3.4-3.8l11.4-0.5 c2-0.1,3.7,1.5,3.8,3.4l0,0C213,217.4,211.5,219.1,209.5,219.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M218.1,234.1l-41.3,2c-2,0.1-3.7-1.5-3.8-3.4l0,0c-0.1-2,1.5-3.7,3.5-3.8l41.3-2 c2-0.1,3.7,1.5,3.8,3.5l0,0C221.6,232.3,220.1,234,218.1,234.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M207.5,249.9l-30,1.4c-2,0.1-3.7-1.5-3.8-3.4l0,0c-0.1-2,1.5-3.7,3.4-3.8l30-1.4 c2-0.1,3.7,1.5,3.8,3.4l0,0C211,248.1,209.5,249.8,207.5,249.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M128.1,240.8l-1.1-4c-1.6-5.7-7.2-9.4-13-8.5l-58.2,6.8C48.5,236,43,242.2,43,249.5l3.3,138.6 c0.1,4.4,3.7,7.9,8.1,7.9c0.4,0,0.7,0,1.1-0.1l208.1-24.3c5-0.6,8.8-4.8,8.8-9.9l-2.8-119.8c-0.1-4.4-3.7-7.9-8.2-7.9 c-0.4,0-0.7,0-1.1,0.1l-120.9,14.1C134.4,249,129.5,245.8,128.1,240.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M128.1,240.8l-1.1-4c-1.6-5.7-7.2-9.4-13-8.5l-58.2,6.8 C48.5,236,43,242.2,43,249.5l3.3,138.6c0.1,4.4,3.7,7.9,8.1,7.9c0.4,0,0.7,0,1.1-0.1l208.1-24.3c5-0.6,8.8-4.8,8.8-9.9l-2.8-119.8 c-0.1-4.4-3.7-7.9-8.2-7.9c-0.4,0-0.7,0-1.1,0.1l-120.9,14.1C134.4,249,129.5,245.8,128.1,240.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDABD"
    },
    d: "M331.6,174.2c-0.9,4.5-1.9,9-2.9,13.4c-1.1,4.4-2.1,8.9-3.3,13.3l-1.8,6.6l-0.2,0.9 c-0.1,0.4-0.2,0.7-0.4,1.1c-0.3,0.8-0.7,1.6-1.2,2.3c-0.6,0.9-1.4,1.7-2.3,2.3c-1,0.7-2.1,1.1-3.3,1.2c-1.8,0.1-3.6-0.3-5.2-1.1 c-1.2-0.7-2.3-1.4-3.4-2.3c-1.9-1.6-3.5-3.5-5-5.6l3.5-3c1.7,1.3,3.4,2.5,5.2,3.5c0.8,0.5,1.6,0.8,2.5,1.1 c0.7,0.2,1.4,0.2,1.4,0.1s-0.1,0-0.2,0s0,0,0-0.2s0.1-0.4,0.2-0.7l0.3-1.4l1.4-6.6l2.9-13.3c0.9-4.4,1.9-8.9,2.9-13.3L331.6,174.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262638"
    },
    d: "M327.5,160.3c-10.4,7.9-10,22.9-10,22.9l18.6,4.4c0,0,5.7-15.1,3.4-20.6 C337.1,161.3,333.4,155.8,327.5,160.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDABD"
    },
    d: "M306.9,203.5l-6.8-6.8l-3.7,10.7c0,0,5.8,3.1,11.3,0.2L306.9,203.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDABD"
    },
    points: "290.6,195.6 289.4,204 296.4,207.3 300.1,196.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDABD"
    },
    points: "387.7,442.9 377.2,443.9 366.4,419 376.8,418  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDABD"
    },
    points: "455,406.1 447.1,413.5 430.2,394.9 438,387.5  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262638"
    },
    d: "M443.5,410l5.9-10.6c0.2-0.4,0.7-0.6,1.1-0.4l9.1,3.5c0.9,0.4,1.3,1.4,0.9,2.3 c0,0.1-0.1,0.1-0.1,0.2c-2.1,3.7-3.3,5.3-5.9,10c-1.6,2.9-4.7,9.5-6.9,13.4c-2.2,3.9-6.2,2-5.7,0.2c2.5-8.3,2-12.9,1.3-16.6 C443.1,411.2,443.2,410.5,443.5,410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262638"
    },
    d: "M375.9,440.7h12.8c0.5,0,0.9,0.3,1,0.8l2.8,10.1c0.2,0.8-0.2,1.7-1.1,2c-0.2,0-0.3,0.1-0.5,0.1 c-4.5,0-6.7,0-12.3,0h-17.2c-4.7,0-5.7-4.7-3.7-5.2c8.7-1.9,13.7-4.6,16.4-7.1C374.5,440.9,375.2,440.7,375.9,440.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "366.4,419.1 372,431.9 382.9,431.9 376.8,418  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "438,387.5 430.2,394.9 438.9,404.5 446.8,397.1  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262638"
    },
    d: "M330.7,158.8c0,0-4.7,2.1,11.1,64.4l43.7-3.8c-2.3-17.7-3.2-28.7,2.1-66c-6.2-0.7-12.5-1-18.8-0.8 c-6.7,0.1-13.3,0.7-19.9,1.7C342.7,155.4,336.7,156.9,330.7,158.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M368.8,152.2c0,0,2.4,0,5.4,0c1.8,2.7-4,14.6-13.4,22.4c-1.4-4.3-4.1-8.1-7.6-11L368.8,152.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M348.9,154.1c0,0-1.1,0.2-3.7,0.8c-1.8,2.7-4.7,14.3,0.5,20.2c1.3-4.5,3.9-8.5,7.5-11.5 L348.9,154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDABD"
    },
    d: "M364.9,130.3c-0.7,6.5-0.9,18.3,3.9,22.2c0,0-5.2,5.3-15.6,11.1c-7.6-5.3-4.2-9.4-4.2-9.4 c7-2.3,6.3-7.6,4.7-12.5L364.9,130.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M353,163.6c0,0,6.4-7,9.7-5.6c3.3,1.3,0.8,3.7,0.5,6s1.3,8.2-3.2,6.7 C355.6,169.1,353,163.6,353,163.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M352.7,163.5c0,0-3-5.4-6.3-4.6c-3.3,0.7-1.3,2.6-1,4.6c0.4,2.6-2.3,7.5,1.6,6.1 C350.9,168.1,352.7,163.5,352.7,163.5z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351,162.3c0,1.1,0.2,2.2,0.6,3.1c0.4-0.6,0.8-1.3,1.1-2c-0.4-0.8-1-1.5-1.5-2.2C351,161.7,351,162,351,162.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M355.3,161.4c-1.4,1.2-2.3,2.3-2.3,2.3c0.4,0.7,0.8,1.4,1.2,2.1c0.7-0.7,1.2-1.7,1.2-2.8 C355.5,162.5,355.5,161.9,355.3,161.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M352.9,165.8c-0.9,0-1.5-1-1.5-3.3c-0.1-2.3,1.7-1,1.7-1s2.4-1.2,2,1.6 C354.8,165.3,353.8,165.8,352.9,165.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M360.3,135l-6.7,6.8c0.4,1.1,0.7,2.3,0.9,3.5c2.7-0.6,6.6-3.4,6.6-6.3 C361.1,137.6,360.8,136.2,360.3,135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262638"
    },
    d: "M354.5,108.3c0,0-7.3,10.1-8.5,14.6c-5,2.9-6-11.4-3.3-20.1C350.9,107.9,354.5,108.3,354.5,108.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDABD"
    },
    d: "M370.6,120.2c-2.7,10.4-3.7,14.8-10,19.2c-9.6,6.5-21.7,0.9-22.2-10c-0.4-9.9,4.1-25.2,15.2-27.4 c7.9-1.6,15.6,3.5,17.2,11.4C371.3,115.6,371.2,117.9,370.6,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262638"
    },
    d: "M376.2,116c0,0-5.2,8.5-5.9,12.2c-3.8,2.6-5.4-8.7-3.8-15.8C368.3,106,376.2,116,376.2,116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262638"
    },
    d: "M374.2,110.1c-1.5,1.1-3.1-3.1-1.6-6.3c-2.9,0.2-6.4-1.5-5.6-4.3c-5.7,1.9-7.8-3.9-7.1-7.9 c0.8-4.9,5-5.9,7.5-4.6c0-2.2,5.5-6.7,7.6-3.2c3.9-1.4,10.1-0.9,10,3.8c2.6,0.1,10.2,3,7.3,9.7c3.3,0.2,5.2,4.4,3.3,7.7 c2.5,1.3,3.5,4.5,2.1,7c-0.3,0.5-0.6,1-1.1,1.4c1.5,3.2-3.1,8-5.6,7.4c-1.9,2.9-4.8,5.1-6.7,2.6c-3.7,2.7-7.9-0.7-6.9-3.4 C373.2,119.5,369,112.6,374.2,110.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M380.3,99.9c2.7,4.6,2.5,9.7-0.5,11.5s-7.7-0.4-10.4-5c-2.7-4.6-2.5-9.7,0.5-11.5 S377.6,95.4,380.3,99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262638"
    },
    d: "M355,107.1c-0.2,1.3-3.7,1-4.8-1.3c-1.5,1.6-5,2.4-6.2,0.7c-2,3.8-6.1,2.8-7.1,1s-1.7-5.2,0.4-5.9 c-1.2-1-0.9-6,2.3-5.4c1.3-2.6,5-5.6,7.7-3.3c1.5-1.2,7.3-3.7,9.7,0.9c1.9-1.3,4.5-0.8,5.8,1.1c0.2,0.3,0.3,0.6,0.5,0.9 c3.8-1,5.4,1.9,5.4,3.4c2.7,0.7,2.9,5.4,1.2,6.4c0.6,2.3,0.3,4.9-2.2,4.6c-0.5,3.2-4.7,3.7-5.7,1.9 C359.2,113.9,353.6,110.9,355,107.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262638"
    },
    d: "M348.6,98.1c3.1-4.3,14.3-6.1,24,0.4c8.8,5.8,8.2,19.1,1.2,18.4S360,108,360,108L348.6,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDABD"
    },
    d: "M371.4,129.5c-1,1.8-2.6,3.2-4.6,3.8c-2.6,0.8-4-1.5-3.3-4.1c0.6-2.3,2.7-5.4,5.4-5.1 c1.9,0.3,3.3,2,3,4C371.9,128.6,371.7,129.1,371.4,129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M341.7,223.1c0,0-14.8,65.5-4.9,111.7c6.6,30.9,30.4,93.4,30.4,93.4l18.7-0.5 c0,0-18.1-65.5-21.8-91.3c-6.4-44.1,9.6-116,9.6-116L341.7,223.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M358.8,236.4l9.3,14.7c-2.8,17.4-4.6,35-5.3,52.7 C349.6,280.3,355.9,248.8,358.8,236.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#262638"
    },
    points: "364.6,429.1 387.7,428.5 386.4,421.5 362.8,422.6  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M351.3,222.4c0,0,8.7,69.4,27.5,107.4c15.2,30.6,55.8,74.2,55.8,74.2l10.4-10.7 c0,0-27.4-47.4-38.7-67.7c-27.7-49.9-5.1-87.9-20.8-106.3L351.3,222.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#262638"
    },
    points: "433.5,405.4 446.9,392.4 442.4,386.3 428.2,400.5  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M385.9,216.7l2.3,3.7c0.2,0.3-0.2,0.6-0.7,0.7l-45.9,4c-0.4,0-0.7-0.1-0.8-0.4l-0.7-3.9 c-0.1-0.3,0.3-0.5,0.7-0.6l44.3-3.8C385.4,216.4,385.7,216.5,385.9,216.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M385.9,216.7l2.3,3.7c0.2,0.3-0.2,0.6-0.7,0.7l-45.9,4 c-0.4,0-0.7-0.1-0.8-0.4l-0.7-3.9c-0.1-0.3,0.3-0.5,0.7-0.6l44.3-3.8C385.4,216.4,385.7,216.5,385.9,216.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M380.4,222.2l1.2-0.1c0.2,0,0.4-0.2,0.4-0.3l-1-5c0-0.2-0.2-0.3-0.5-0.2l-1.2,0.1 c-0.2,0-0.4,0.2-0.4,0.3l1,5C379.9,222.1,380.1,222.2,380.4,222.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M345,225.2l1.2-0.1c0.2,0,0.4-0.2,0.4-0.3l-1-5c-0.1-0.2-0.3-0.3-0.5-0.2l-1.2,0.1 c-0.2,0-0.4,0.2-0.4,0.3l1,5C344.6,225.2,344.8,225.3,345,225.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M362.7,223.7l1.2-0.1c0.2,0,0.4-0.2,0.4-0.3l-1-5c0-0.1-0.2-0.3-0.5-0.2l-1.2,0.1 c-0.2,0-0.4,0.2-0.4,0.3l1,5C362.2,223.6,362.5,223.7,362.7,223.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262638"
    },
    d: "M353,119.8c-0.2,0.9-0.8,1.5-1.3,1.4c-0.6-0.1-0.9-0.9-0.7-1.8s0.8-1.5,1.3-1.4 S353.2,118.9,353,119.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1929 -0.9812 0.9812 0.1929 160.791 430.8967)",
    style: {
      fill: "#262638"
    },
    cx: 342.3,
    cy: 117.7,
    rx: 1.6,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262638"
    },
    d: "M342.9,116.2l-1.9-1C340.9,115.2,341.7,117.1,342.9,116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDAB7E"
    },
    d: "M346.7,120c-1.1,1.8-2.5,3.4-4.1,4.9c0.7,0.8,1.8,1.3,2.9,1.2L346.7,120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262638"
    },
    d: "M349.4,130.1c1.8,0,3.5-0.6,4.9-1.9c0.1-0.1,0.1-0.2,0-0.3c-0.1-0.1-0.2-0.1-0.3,0c0,0,0,0-0.1,0.1 c-1.7,1.5-3.9,2-6.1,1.6c-0.1,0-0.2,0.1-0.2,0.2l0,0c0,0.1,0,0.2,0.1,0.2l0,0C348.4,130.1,348.9,130.1,349.4,130.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262638"
    },
    d: "M358.8,116.5c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.3-0.4,0.1-0.6c-0.8-1.4-2.3-2.3-3.9-2.4 c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.2,0.4,0.4,0.4l0,0c1.3,0.1,2.5,0.9,3.2,2.1C358.5,116.4,358.7,116.5,358.8,116.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262638"
    },
    d: "M340.7,113c0.1,0,0.1,0,0.2,0c1.1-0.7,2.5-0.8,3.8-0.2c0.2,0.1,0.5,0,0.6-0.2s0-0.4-0.2-0.5 c-1.5-0.7-3.2-0.6-4.6,0.3c-0.2,0.1-0.3,0.4-0.2,0.6C340.4,113,340.5,113.1,340.7,113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDABD"
    },
    d: "M389.4,163.3c0.8,0.8,1.4,1.4,2,2.2c0.6,0.7,1.2,1.4,1.8,2.1c1.2,1.4,2.3,2.9,3.3,4.5 c2.1,3.1,3.9,6.3,5.5,9.6c1.6,3.4,2.8,6.8,3.8,10.4c0.5,1.8,0.9,3.7,1.2,5.4c0.6,2.6,0.3,5.3-0.8,7.7c-0.7,1.3-1.6,2.4-2.7,3.2 c-1,0.7-2,1.4-3.2,1.8c-2,0.8-4,1.2-6.1,1.4c-3.7,0.4-7.4,0.3-11.1-0.1c-7.1-0.8-14-2.3-20.8-4.4l1.1-4.4 c3.3,0.5,6.7,1.1,10.1,1.4c3.4,0.4,6.7,0.7,10.1,0.7c3.2,0.1,6.4-0.1,9.6-0.5c1.4-0.2,2.7-0.6,4-1.2c0.8-0.3,1.4-0.9,1.8-1.6 c0.1-0.3,0.2-0.6,0.1-0.9c0-0.2,0-0.4,0-0.7c0-0.2-0.1-0.5-0.2-0.9c-0.3-1.6-0.8-3.1-1.3-4.6c-1-3.1-2.2-6-3.7-8.9 c-1.4-2.9-3.1-5.7-5-8.3c-0.9-1.3-1.9-2.6-2.9-3.9c-0.5-0.6-1-1.2-1.5-1.8s-1.1-1.2-1.5-1.7L389.4,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDABD"
    },
    d: "M366.2,203.4l-8.5-4.5l-0.4,11.3c0,0,6.1,0.4,9.6-2.4L366.2,203.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#35A464"
    },
    points: "351.2,264.1 358.3,187.7 343.2,176.2 297.3,171.9 289.4,258.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "351.2,264.1 358.3,187.7 343.2,176.2 297.3,171.9  289.4,258.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#35A464"
    },
    points: "358.3,187.7 343.2,176.2 347.2,189.9  "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#35A464"
    },
    cx: 294.8,
    cy: 253.1,
    r: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 294.8,
    cy: 253,
    r: 14.9
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#35A464"
    },
    points: "304,251.7 297.4,251 298.2,244.4 293.4,243.8 292.7,250.4 286.1,249.6 285.5,254.4  292.1,255.2 291.3,261.7 296.1,262.3 296.8,255.7 303.4,256.5  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#35A464",
      enableBackground: "new"
    },
    d: "M347,203.5L347,203.5c-0.3,2.8-2.7,4.9-5.6,4.6l0,0 l-33.5-3.1c-2.8-0.3-4.9-2.8-4.6-5.6l0,0c0.3-2.8,2.7-4.9,5.6-4.6l0,0l33.5,3.1C345.2,198.2,347.3,200.7,347,203.5L347,203.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#35A464",
      enableBackground: "new"
    },
    d: "M335.6,217.3L335.6,217.3c-0.3,2.8-2.7,4.9-5.6,4.6l0,0 l-23.4-2.2c-2.8-0.3-4.9-2.7-4.6-5.6l0,0l0,0c0.3-2.8,2.7-4.9,5.6-4.6l0,0l23.4,2.2C333.8,212.1,335.9,214.5,335.6,217.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDABD"
    },
    points: "352.5,199.6 353.7,208 357.3,210.2 357.6,198.9  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262638"
    },
    d: "M387.5,153.4c5.4,0.9,12.9,16.3,12.9,16.3l-13.5,12.2c0,0-10.8-11.7-10.2-18.7 C377.2,157.3,380.7,152.2,387.5,153.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M441.4,415.7c0.1,0,0.3,0,0.4-0.1c1.3-0.4,2.1-2.8,2.5-4.2c0-0.1,0-0.2-0.1-0.2 c-0.1-0.1-0.2-0.1-0.2,0c-0.4,0.2-3.8,2-3.9,3.4c0,0.3,0.1,0.6,0.4,0.8C440.8,415.6,441.1,415.7,441.4,415.7z M443.9,411.8 c-0.6,1.9-1.4,3.2-2.1,3.4c-0.3,0.1-0.7,0-1-0.2c-0.1-0.1-0.2-0.2-0.2-0.4C440.6,413.8,442.6,412.5,443.9,411.8L443.9,411.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M440.9,412.3c1.2,0,2.3-0.3,3.4-0.8c0.1,0,0.1-0.1,0.1-0.2s0-0.1-0.1-0.2s-2.8-1.6-4.3-1 c-0.4,0.1-0.7,0.4-0.8,0.8c-0.2,0.4-0.1,0.8,0.2,1C439.8,412.2,440.4,412.4,440.9,412.3z M443.7,411.4c-1.2,0.5-3.4,0.8-4,0.3 c-0.1-0.1-0.2-0.2-0.1-0.6c0.1-0.2,0.3-0.4,0.5-0.5C441.1,410.2,442.9,411,443.7,411.4L443.7,411.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M370.2,442.8c1.2,0,2.3-0.2,3.5-0.5c0.1,0,0.2-0.2,0.1-0.3c0-0.1-0.1-0.1-0.1-0.1 c-0.5-0.3-5.2-2.4-6.4-1.6c-0.2,0.1-0.3,0.4-0.3,0.7c0,0.5,0.2,0.9,0.6,1.2C368.4,442.6,369.3,442.8,370.2,442.8z M372.9,442 c-1.4,0.3-3.9,0.6-5-0.2c-0.3-0.2-0.4-0.5-0.5-0.9c0-0.1,0-0.2,0.1-0.3C368.2,440.2,371,441.2,372.9,442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35A464"
    },
    d: "M373.6,442.3h0.1c0.1-0.1,0.1-0.1,0.1-0.2c0-0.2-1.1-4.8-3.7-4.5c-0.6,0.1-0.8,0.4-0.8,0.6 C369.1,439.4,372.1,441.7,373.6,442.3L373.6,442.3z M370.4,438c1.6,0,2.6,2.7,2.9,3.7c-1.5-0.8-3.7-2.7-3.5-3.5 c0-0.1,0-0.2,0.5-0.3L370.4,438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262638"
    },
    d: "M352.5,118.1l-1.9-1C350.6,117.1,351.3,119,352.5,118.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationAdd);
export default __webpack_public_path__ + "static/media/illustration__add.2d76a9a31ea8e487e73879137bec093c.svg";
export { ForwardRef as ReactComponent };